export const BUTTON_TYPE = {
    CLOSE: 'close',
    CANCEL: 'cancel',
    ACTIONABLE: 'actionable'
};

export const ACTION = {
    LAUNCH_CASHIER: 'launchCashier',
    SWITCH_TO_GAME: 'switchtogame',
    OPEN_URLS: 'openUrls'
};

export const BROWSER_DEFAULT_FONT_SIZE = 14;
